import { styled } from "goober";

export const ControlButton = styled("button")`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 0.5px solid var(--border-alpha);
  border-radius: 9999px;
  background: var(--surface-primary);
  color: var(--text-primary);
  cursor: pointer;

  &:hover {
    background: var(--alpha4);
  }
`;
